import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { toast } from 'sonner'
import type {
    CreateProductPayload,
    UpdateProductPayload,
} from '@/lib/api/product-api'
import { Button } from '@/components/ui/button'
import { ProductForm } from '@/components/products/product-form'
import { useCreateProduct } from '@/hooks/use-product-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/products/new')({
    component: NewProductPage,
})

function NewProductPage() {
    const navigate = useNavigate()
    const createProduct = useCreateProduct()

    const handleSubmit = async (
        data: CreateProductPayload | UpdateProductPayload,
    ) => {
        try {
            const res = await createProduct.mutateAsync(
                data as CreateProductPayload,
            )
            toast.success(m.toast_product_create_success())
            if (res.data?.id) {
                void navigate({
                    to: '/products/$productId',
                    params: { productId: res.data.id },
                    replace: true,
                })
            } else {
                void navigate({ to: '/products' })
            }
        } catch {
            toast.error(m.toast_product_create_error())
        }
    }

    return (
        <div className="max-w-2xl space-y-4 p-4 md:p-6">
            <div className="flex items-center gap-3">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => navigate({ to: '/products' })}
                >
                    <ArrowLeft className="size-4" />
                </Button>
                <h1 className="text-xl font-semibold">{m.product_add_new()}</h1>
            </div>
            <div className="rounded-lg border p-6">
                <ProductForm
                    onSubmit={handleSubmit}
                    onCancel={() => navigate({ to: '/products' })}
                    isLoading={createProduct.isPending}
                />
            </div>
        </div>
    )
}
